/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';

/**
 * 
 * @export
 * @interface EListSearchTypeInt32CombinableCriteria
 */
export interface EListSearchTypeInt32CombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeInt32CombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {number}
     * @memberof EListSearchTypeInt32CombinableCriteria
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof EListSearchTypeInt32CombinableCriteria
     */
    secondaryValue?: number;
}

/**
 * Check if a given object implements the EListSearchTypeInt32CombinableCriteria interface.
 */
export function instanceOfEListSearchTypeInt32CombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeInt32CombinableCriteriaFromJSON(json: any): EListSearchTypeInt32CombinableCriteria {
    return EListSearchTypeInt32CombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeInt32CombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeInt32CombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function EListSearchTypeInt32CombinableCriteriaToJSON(value?: EListSearchTypeInt32CombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

